import React from 'react';
import { HeroSection } from './components/HeroSection';
import { BenefitsSection } from './components/BenefitsSection';
import { WhoIsItFor } from './components/WhoIsItFor';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <HeroSection data-id="element-2" />
        <BenefitsSection data-id="element-3" />
        <WhoIsItFor data-id="element-4" />
        <PricingCTA data-id="element-5" />
      </main>
      <Footer data-id="element-6" />
    </div>;
}